import '../styles/layouts/base-layout.scss';
import Flex from '../components/Flex';
import { Content, Layout } from '../components/Layout';
import Sider from './Sider';
import Header from './Header';
import Loading from './Loading';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';

const BaseLayout = () => {
  return (
    <Flex gap="middle" wrap>
      <Layout className="sys-layout">
        <Sider />
        <Layout className="sys-layout__body">
          <Header />
          <Content className="sys-layout__content">
            <Outlet />
            <Loading />
          </Content>
          <Footer />
        </Layout>
      </Layout>
    </Flex>
  );
};

export default BaseLayout;
